import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Eye, UserCheck, Database } from 'lucide-react';

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-50 to-premium-50">
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-r from-burgundy-100 via-cream-100 to-premium-100">
        <div className="container mx-auto px-4 safe-area-inset">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-6">
              Privacy Policy
            </h1>
            <div className="w-24 h-1 gold-gradient rounded-full mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 leading-relaxed">
              Your privacy is important to us. This policy explains how we collect, use, and protect your personal information.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 safe-area-inset">
          <div className="max-w-4xl mx-auto space-y-8">
            {[
              {
                icon: Database,
                title: "Information We Collect",
                content: "We collect information you provide when placing orders, including your name, contact details, delivery address, and cake preferences. We also collect payment information to process your orders securely."
              },
              {
                icon: Eye,
                title: "How We Use Your Information",
                content: "Your information is used to process orders, communicate with you about your cake requirements, arrange deliveries, and improve our services. We may also send you updates about new products with your consent."
              },
              {
                icon: Lock,
                title: "Data Protection",
                content: "We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Your payment information is processed through secure payment gateways."
              },
              {
                icon: UserCheck,
                title: "Information Sharing",
                content: "We do not sell, trade, or rent your personal information to third parties. We may share information with delivery partners only as necessary to fulfill your orders, and they are bound by confidentiality agreements."
              }
            ].map((section, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="premium-card bento-card"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-burgundy-400 to-burgundy-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <section.icon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-serif font-semibold text-gray-900 mb-4">
                      {section.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {section.content}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
